<template>
  <div :class="['form-panel', panelClass, small ? 'form-panel-small' : '']">
    <div class="form-panel-heading">{{title}}</div>
    <div class="form-panel-body">
      <slot />
    </div>
  </div>
</template>

<style scoped lang="scss">
.form-panel {
  margin-bottom: 20px;
  background-color: #fff;
  border: 1px solid #e5e6e7;
  border-radius: $layout-minor-border-radius;
  padding: 4px;
}

.form-panel > .form-panel-heading {
  font-weight: bold;
  background-color: #f5f5f5;
  border-radius: 14px;
  padding: 6px 10px;
  margin-bottom: 10px;
}
.form-panel-small {
  font-size: 0.7rem;
}

.form-panel.panel-warning > .form-panel-heading {
  background-color: #f0ad4e;
  color: #fff;
}

.form-panel > .form-panel-body {
  padding: 2px 2px;
}
</style>

<script>
export default {
  name: 'FormPanel',
  props: {
    title: String,
    panelClass: {
      type: String,
      default: 'panel-default'
    },
    small: Boolean
  }
}
</script>